export enum MeasurementUnit {
	Feet = 'Feet',
	Meters = 'Meters'
}
